/**
 * @file 获取班级动态
 * @author liudy
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IFeedListInput {
    class_id: number; // int，班级编号，创建班级时为空
    page: number; // 页码;
    size: number; // 每页数量;
    type?: number; // 1：班级通知；2：学习任务-课程；3：学习任务-小节；4：学习任务-学习项目；
}

export const getFeedList = (data: IFeedListInput): Promise<IList<IFeedSource>> => {
    return fetchData(Api.CLASS_FEED_LIST, data).then((res: IListResponse<IFeedSource>) => {
        return res.data as IList<IFeedSource>;
    });
};
